// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content--znHp7{flex:1 1 auto;height:100%}\n", ""]);
// Exports
exports.locals = {
	"content": "content--znHp7"
};
module.exports = exports;
